//import Vue from 'vue'

const state = {
}

const getters = {
    status2variant(state) {
        return (status) => {
            const table = {
                'draft': 'dark',
                'listed': 'info',
                'sold': 'danger',
                'completed': 'success',
                //'': 'warning',
            }
            return table[status]
        }
    },
    is_public2variant(state) {
        return (is_public) => {
            const table = {
                false: 'dark',
                true: 'warning',
            }
            return table[is_public]
        }
    },
}

const mutations = {
}

const actions = {
    async save (context, data) {
        return axios.post('/api/v1/inventories' + (data.uuid ? '/' + data.uuid : ''), data)
            .then((response) => {
                return response
            })
            .catch((error) => {
                return Promise.reject(error.response.data.errors || {})
            })

//        const response = await axios.post('/api/v1/inventories' + (data.id ? '/' + data.id : ''), data)
//            .catch(error => error.response || null)
//        return response
    },
    async destroy (context, data) {
        const response = await axios.delete('/api/v1/inventories/' + data.uuid)
            .catch(error => error.response || null)
        return response
    },
    async index (context, data) {
        const response = await axios.get('/api/v1/inventories' + (typeof data  === 'string' ? '/' + data : ''), {
            params: (typeof data === 'object' ? data : null)
        })
        .catch(error => error.response || null)
        return response
    },
    async list (context, id) {
        const response = await axios.get('/api/v1/i/', {
                params: {
                    seller_uuid: id,
                }
            })
            .catch(error => error.response || null)
        return response
    },
    async show (context, id) {
        const response = await axios.get('/api/v1/i/' + id)
            .catch(error => error.response || null)
        return response
    },
    async answer (context, data) {
        const response = await axios.post('/api/v1/i/' + data.form_uuid + (data.answer_uuid ? '/' + data.answer_uuid : ''), data)
            .catch(error => error.response || null)

        return response
    },
    async favorite (context, data) {
        const response = await axios.post('/api/v1/inventories/' + data.uuid + '/favorite')
            .catch(error => error.response || null)
        return response
    },
    async status (context, data) {
        const response = await axios.put('/api/v1/inventories/' + data.id + '/status', data)
            .catch(error => error.response || null)
        return response
    },
    async download (context, data) {
        data = Object.assign(data, { download: true, })
        const response = await axios.get('/api/v1/inventories', {
            params: (typeof data === 'object' ? data : null),
            responseType: 'blob',
            dataType: 'binary',
            headers: { 'Cache-Control': 'no-cache' },
        })
        .catch(error => error.response || null)
        Vue.prototype.download(response)
        return response
    },

    async sync_item_caches (context, data) {
        const response = await axios.post('/api/v1/inventories/' + data.uuid + '/sync_item_caches', null)
            .catch(error => error.response || null)

        return response
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

